import { MessageSquareText } from 'lucide-react';
import React from 'react';

export const PingToChatIcon = (props) => {
    return (
        <MessageSquareText {...props}/>
    );
}
